export const STAFF_REQUEST_PARAMS = {
  billingid: '',
  debounceBillingid: '',
  debounceQuery: '',
  page: 1,
  perPage: 5,
  query: '',
  screen: 'staff'
};
